import React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';

const DeleteConfirmationModal = ({ open, onClose, onConfirm }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="delete-confirmation-modal">
      <Box sx={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', 
        width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2 
      }}>
        <Typography id="delete-confirmation-modal" variant="h6" component="h2" gutterBottom>
          Confirm Deletion
        </Typography>
        <Typography>
          Are you sure you want to delete this? This action cannot be undone.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="outlined" color="error" onClick={onConfirm}>
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmationModal;
